import React from 'react';

const SmartPhoneWarning = () => {
  return (
   
      <div className="smartphone--warning">
        <div className="container">
          <div className="row m-auto h-100">
            <div className="col-12 m-auto text-center">
              <div>
                <h4>Install our app and experience a better service</h4>
                <span>
                  We highly recommend using our mobile app for a better
                  experience
                </span>
              </div>
              <div>
                <img
                  className="qr--code"
                  src="assets/svg/qr-code.svg"
                  alt="QR Code"
                  data-width={296}
                  data-height={296}
                  title="qr-code"
                />
              </div>
              <div className="download--app d-flex justify-content-center mt-5">
                <div>
                  <a href="#" type="button" className="btn app d-flex">
                    <div className="icon apple">
                      <svg
                        width={82}
                        height={100}
                        viewBox="0 0 82 100"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M67.9302 53.1933C67.8242 40.5484 78.2792 34.4026 78.7384 34.12C72.8045 25.5017 63.621 24.3008 60.4068 24.1948C52.7069 23.3825 45.2188 28.8219 41.2982 28.8219C37.307 28.8219 31.2318 24.3008 24.7327 24.4068C16.3617 24.548 8.4851 29.387 4.21127 36.9457C-4.65427 52.3103 1.95074 74.9157 10.4631 87.3486C14.7369 93.4238 19.6818 100.241 26.2162 99.9935C32.574 99.7462 34.9758 95.9316 42.6404 95.9316C50.2697 95.9316 52.4949 99.9935 59.1353 99.8522C65.9875 99.7462 70.2614 93.7417 74.3939 87.5959C79.3035 80.6376 81.2815 73.7501 81.3521 73.3969C81.1755 73.3262 68.0715 68.3106 67.9302 53.1933"
                          fill="white"
                        />
                        <path
                          d="M55.3911 16.0357C58.8173 11.7619 61.1484 5.93391 60.5127 0C55.5677 0.211925 49.3513 3.42613 45.7839 7.62931C42.6403 11.338 39.8146 17.3779 40.521 23.0645C46.1017 23.4884 51.8237 20.2389 55.3911 16.0357"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <div className="text d-flex">
                      <div className="m-auto">
                        <div>Available on the</div>
                        <div className="master">App Store</div>
                      </div>
                    </div>
                  </a>
                </div>
                <div>
                  <a href="#" type="button" className="btn app d-flex">
                    <div className="icon">
                      <svg
                        width={94}
                        height={100}
                        viewBox="0 0 94 100"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M69.0444 65.4398C80.8801 58.9618 89.9192 54.0137 90.7415 53.5631C93.1942 52.2206 95.7639 48.7946 90.7415 46.0562C89.1272 45.1743 80.3312 40.378 69.0305 34.2128L53.4878 49.8747L69.0444 65.4398Z"
                          fill="url(#paint0_linear)"
                        />
                        <path
                          d="M53.4867 49.8746L3.7749 99.9658C4.89754 100.108 6.2478 99.811 7.8009 98.9609C11.0163 97.201 45.547 78.2997 69.0441 65.4382L53.4867 49.8746V49.8746Z"
                          fill="url(#paint1_linear)"
                        />
                        <path
                          d="M53.4872 49.8747L69.0299 34.2128C69.0299 34.2128 11.2599 2.69461 7.80136 0.807808C6.47201 0.0823533 5.02265 -0.17082 3.73975 0.114871L53.4872 49.8747Z"
                          fill="url(#paint2_linear)"
                        />
                        <path
                          d="M53.487 49.8747L3.73876 0.115662C1.68395 0.574006 0 2.35241 0 5.92704C0 11.7338 0 89.1205 0 93.9958C0 97.3622 1.32471 99.7298 3.77438 99.9659L53.487 49.8747Z"
                          fill="url(#paint3_linear)"
                        />
                        <defs>
                          <linearGradient
                            id="paint0_linear"
                            x1="79.0981"
                            y1="60.3174"
                            x2="66.4636"
                            y2="35.5207"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#FCD08F" />
                            <stop offset={1} stopColor="#F79673" />
                          </linearGradient>
                          <linearGradient
                            id="paint1_linear"
                            x1="60.7265"
                            y1="56.6254"
                            x2="12.6196"
                            y2="108.214"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#E74047" />
                            <stop offset={1} stopColor="#7F50A0" />
                          </linearGradient>
                          <linearGradient
                            id="paint2_linear"
                            x1="60.9828"
                            y1="42.6363"
                            x2="12.1127"
                            y2="-7.97026"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#E6FFAB" />
                            <stop offset={1} stopColor="#47BEBC" />
                          </linearGradient>
                          <linearGradient
                            id="paint3_linear"
                            x1="26.7441"
                            y1="99.9657"
                            x2="26.7441"
                            y2="0.116054"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#84E9DB" />
                            <stop offset={1} stopColor="#197491" />
                          </linearGradient>
                        </defs>
                      </svg>
                    </div>
                    <div className="text d-flex">
                      <div className="m-auto">
                        <div>Android App on</div>
                        <div className="master">Google Play</div>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};

export default SmartPhoneWarning;
